const SITE_TITLE = 'Dynamic Brain Platform';
const SITE_SLOGAN = 'Official Site';
// Replaces the Universal Analytics property (UA-23709948-1), shut down in 2023.
const GOOGLE_ANALYTICS_TRACKING_ID = 'G-HZHCC88CP2';
const XOONIPS_ITEMTYPES = [
    'model',
    'data',
    'tool',
    'book',
    'paper',
    'conference',
    'url',
    'presentation',
    'simulator',
    'stimulus',
    'memo',
    'files',
    'binder',
];
const PICO_MODULES = ['documents', 'hackathon'];

// Vite's BASE_URL always carries a trailing slash ('/' when the app is served
// from the document root). Strip it so it can be concatenated the same way
// CRA's Config.BASE_URL was.
const BASE_URL = import.meta.env.BASE_URL.replace(/\/$/, '');

export type MultiLang = 'en' | 'ja';

const Config = {
    SITE_TITLE,
    SITE_SLOGAN,
    GOOGLE_ANALYTICS_TRACKING_ID,
    XOONIPS_ITEMTYPES,
    PICO_MODULES,
    BASE_URL,
};

export default Config;
